/**
 * News & Events Filter Bar
 * Search, category filter, type toggle, and sort controls
 */
import React from 'react';
import { Search, SlidersHorizontal, Calendar, Newspaper } from 'lucide-react';

const defaultCategories = ['All Categories', 'Announcements', 'Financial', 'Community', 'Institutional'];
const sortOptions = ['Latest', 'Oldest', 'Popular'];

const NewsEventsFilterBar = ({
  searchQuery,
  onSearchChange,
  activeCategory,
  onCategoryChange,
  activeType,
  onTypeChange,
  sortBy,
  onSortChange,
  categories,
}) => {
  const categoryOptions = categories && categories.length > 0 ? categories : defaultCategories;
  return (
    <section className="bg-white border-b border-gray-100 py-5">
      <div className="container mx-auto px-6 md:px-8 lg:px-12">
        {/* Search & Filters Row */}
        <div className="flex flex-col lg:flex-row lg:items-center gap-4">
          {/* Search Input */}
          <div className="relative flex-1 max-w-xl">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
            <input
              type="text"
              placeholder="Search news, events, announcements..."
              value={searchQuery}
              onChange={(e) => onSearchChange(e.target.value)}
              className="w-full pl-10 pr-4 py-2.5 bg-gray-50 border border-gray-200 rounded-lg text-sm text-gray-700 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#ca9a37]/30 focus:border-[#ca9a37] transition-all"
            />
          </div>

          {/* Type Toggle */}
          <div className="flex items-center bg-gray-100 rounded-lg p-1">
            <button
              type="button"
              onClick={() => onTypeChange('all')}
              className={`flex items-center gap-1.5 px-3 py-1.5 rounded-md text-xs font-medium transition-all ${
                activeType === 'all'
                  ? 'bg-[#2f3951] text-white shadow-sm'
                  : 'text-gray-500 hover:text-gray-700'
              }`}
            >
              <SlidersHorizontal className="w-3.5 h-3.5" />
              All
            </button>
            <button
              type="button"
              onClick={() => onTypeChange('news')}
              className={`flex items-center gap-1.5 px-3 py-1.5 rounded-md text-xs font-medium transition-all ${
                activeType === 'news'
                  ? 'bg-[#2f3951] text-white shadow-sm'
                  : 'text-gray-500 hover:text-gray-700'
              }`}
            >
              <Newspaper className="w-3.5 h-3.5" />
              News
            </button>
            <button
              type="button"
              onClick={() => onTypeChange('event')}
              className={`flex items-center gap-1.5 px-3 py-1.5 rounded-md text-xs font-medium transition-all ${
                activeType === 'event'
                  ? 'bg-[#2f3951] text-white shadow-sm'
                  : 'text-gray-500 hover:text-gray-700'
              }`}
            >
              <Calendar className="w-3.5 h-3.5" />
              Events
            </button>
          </div>

          {/* Category Filter */}
          <select
            value={activeCategory}
            onChange={(e) => onCategoryChange(e.target.value)}
            className="px-3 py-2.5 bg-gray-50 border border-gray-200 rounded-lg text-sm text-gray-700 focus:outline-none focus:ring-2 focus:ring-[#ca9a37]/30 focus:border-[#ca9a37] cursor-pointer"
          >
            {categoryOptions.map((cat) => (
              <option key={cat} value={cat}>
                {cat}
              </option>
            ))}
          </select>

          {/* Sort Dropdown */}
          <select
            value={sortBy}
            onChange={(e) => onSortChange(e.target.value)}
            className="px-3 py-2.5 bg-gray-50 border border-gray-200 rounded-lg text-sm text-gray-700 focus:outline-none focus:ring-2 focus:ring-[#ca9a37]/30 focus:border-[#ca9a37] cursor-pointer"
          >
            {sortOptions.map((opt) => (
              <option key={opt} value={opt}>
                Sort: {opt}
              </option>
            ))}
          </select>
        </div>
      </div>
    </section>
  );
};

export default NewsEventsFilterBar;
